import { httpAuth2 } from "@/api/auth";

export const searchRequests = {
  search_omni: function ({ context, data } = {}) {
    return httpAuth2.post("/v1/search/omni", { context, json: data }).json();
  },
};
